/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Ctrl_S2_DescInputs */

const en_mk_ctrl_s2_desc = /** @type {(inputs: Mk_Ctrl_S2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonymous pass rate per agent, model and task kind across all Bystep verifications. One-click opt-out in Settings.`)
};

const id_mk_ctrl_s2_desc = /** @type {(inputs: Mk_Ctrl_S2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pass-rate anonim per agent, model, dan jenis task dari seluruh verifikasi Bystep. Opt-out satu klik di Pengaturan.`)
};

/**
* | output |
* | --- |
* | "Anonymous pass rate per agent, model and task kind across all Bystep verifications. One-click opt-out in Settings." |
*
* @param {Mk_Ctrl_S2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_ctrl_s2_desc = /** @type {((inputs?: Mk_Ctrl_S2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Ctrl_S2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_ctrl_s2_desc(inputs)
	return en_mk_ctrl_s2_desc(inputs)
});